export default {
  title: 'Preisdetails',
  subtotal: 'Zwischensumme',
  method_fee: 'Liefergebühr',
  tip: 'Tipp',
  service_fee: 'Online-Bearbeitung',
  payment_method_upcharge_fee: 'PayPal-Gebühr',
  discount: 'Rabatt',
  taxes: 'Steuern',
  total: 'Gesamt',
};
